import styled, { keyframes } from 'styled-components';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

// Components
import FontAwesomeIcon from '../../../components/common/FontAwesomeIcon';
import LazyImg from '../../../modules/acropolisCommon/components/LazyImg';
import { Text } from '../../../components/common/Texts';
import BarProgress from '../../../components/common/BarProgress';

// Material UI
import Button from '@mui/material/Button';

const CareerCard = ({ value }) => {
    const [openInfo, setOpenInfo] = useState(false);

    const handleShowInfo = () => {
        setOpenInfo(!openInfo);
    };

    const verMasBtns =
        value.product_line === 'Diplomados' ||
        value.product_line === 'Workshops' ||
        value.product_line === 'Especialización Online' ||
        value.product_line === 'Certificaciones';

    const masInfoBtns =
        value.product_line !== 'Diplomados' &&
        value.product_line !== 'Certificaciones' &&
        value.product_line !== 'Major' &&
        value.product_line !== 'Doctorado' &&
        value.product_line !== 'Maestría';

    return (
        <BusinessCardContainer>
            {!openInfo && (
                <>
                    <ImageWrapper>
                        <LazyImg
                            src={
                                !!value?.image.length
                                    ? value?.image
                                    : 'https://www.aden.org/files/sites/9/2018/09/Workshop_Miami_magazine.jpg'
                            }
                            width="100%"
                            height="136px"
                            borderRadius="20px 20px 0 0"
                            alt="objeto de aprendizaje"
                        />
                    </ImageWrapper>
                    <Body>
                        <BarProgress value={0} />
                        <NombrePublicacion>{value?.name}</NombrePublicacion>
                        <DescriptionWrapper>
                            <Description>
                                {!!value?.description
                                    ? parse(value?.description)
                                    : 'No posee una descripción'}
                            </Description>
                            <div>
                                <InfoButton onClick={handleShowInfo}>
                                    <FontAwesomeIcon icon="fa-regular fa-plus" />
                                    Ver más información
                                </InfoButton>
                            </div>
                        </DescriptionWrapper>
                    </Body>
                </>
            )}
            <Footer>
                <Link to={'/#'}>
                    {verMasBtns && (
                        <Button
                            onClick={() => window.open(value?.nueva_url || '#')}
                            color="primary"
                        >
                            Ver más
                        </Button>
                    )}
                    {!verMasBtns && (
                        <Button
                            onClick={() => window.open(value?.url || '#')}
                            color="primary"
                        >
                            Contactar Asesor
                        </Button>
                    )}
                    {masInfoBtns && (
                        <Button
                            onClick={() => window.open(value?.url || '#')}
                            variant="outlined"
                        >
                            {value.product_line === 'Workshops'
                                ? 'Inscribirme'
                                : 'Más información'}
                        </Button>
                    )}
                </Link>
            </Footer>
            {!!openInfo && (
                <MoreInfoWrapper>
                    <Text
                        color="#4F4F4F"
                        fontSize="11px"
                        lineHeight="140%"
                        fontWeight="600"
                    >
                        INFORMACIÓN DEL CURSO
                    </Text>
                    <Text
                        color="#B31D15"
                        fontSize="16px"
                        lineHeight="140%"
                        fontWeight="700"
                    >
                        {value?.name}
                    </Text>
                    <DesciptionWrapper>
                        <Text
                            color="#000000"
                            fontSize="13px"
                            lineHeight="19px"
                            fontWeight="400"
                        >
                            {!!value?.description
                                ? parse(value?.description)
                                : 'No posee una descripción'}
                        </Text>
                    </DesciptionWrapper>
                    <InfoButton onClick={handleShowInfo}>
                        <FontAwesomeIcon icon="fa-light fa-arrow-turn-left" />
                        Volver
                    </InfoButton>
                </MoreInfoWrapper>
            )}
        </BusinessCardContainer>
    );
};

export default CareerCard;

const BusinessCardContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow:
        0px 3px 6px 0px rgba(0, 0, 0, 0.16),
        0px 3px 6px 0px rgba(0, 0, 0, 0.23);
    width: 340px;
    height: 380px;
    border-radius: 20px;
    overflow: hidden;

    @media screen and (max-width: 768px) {
        max-width: 300px;
    }

    @media screen and (max-width: 320px) {
        width: 250px;
    }
`;

const ImageWrapper = styled.div`
    position: relative;
`;

const Body = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding: 1rem;
    height: 100%;
`;

const NombrePublicacion = styled.h1`
    font-size: 1rem;
    font-weight: 700;
    text-align: start;
    color: #222222;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 100%;

    @media screen and (max-width: 996px) {
        font-size: 1.2rem;
    }
`;

const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    height: 100%;
`;

const Description = styled.p`
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    max-height: 2.2rem;
    text-overflow: ellipsis;
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
    color: #999999;

    @supports (-webkit-line-clamp: 2) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: initial;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0 1rem 1rem 1rem;
    border-top: 1px solid #fafafa;
    margin-top: auto;
    background-color: #f1f1f1;
    height: 100%;
`;

const RedirectButton = styled(Button)`
    border-radius: var(--border-radius_rounded);
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    min-width: 80px;
    box-shadow: none !important;
`;

const InfoButton = styled.span`
    cursor: pointer;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: #616161;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: .5;
    }
    100% {
        opacity: 1;
    }
`;

const MoreInfoWrapper = styled.section`
    box-sizing: border-box;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    width: 100% !important;
    padding: 1rem;
    height: calc(100% - 74px);
    border-radius: 20px 20px 0 0;
    animation: ${fadeIn} 0.3s ease-in-out;
    background-color: #ffffff;
    border-top: 20px solid #e0e0e0;
`;

const DesciptionWrapper = styled.div`
    height: 156px;
    overflow-y: auto;
`;
